import { useState } from 'react';
import { useIntl } from 'react-intl';
import DataTabs from '@rio-cloud/rio-uikit/DataTabs';
import DataTab from '@rio-cloud/rio-uikit/DataTab';
import WarrantyHistory from './warrantyHistory';
import TechnicalSupportCalls from './technicalSupportCalls';
import Revisions from './revisions';
import Occurrences from './occurrences';

interface Props {
    chassis?: string;
    customer?: string;
}

export default function VehicleHistoryPage({ chassis, customer }: Props) {
    const intl = useIntl();
    const translate = (id?: string) => (id ? intl.formatMessage({ id }) : undefined);
    const [activeTab, setActiveTab] = useState('warrantyHistory');

    return (
        <div className='mx-auto px-4 pb-10' style={{ contain: 'inline-size' }}>
            <DataTabs
                activeKey={activeTab}
                onSelectTab={setActiveTab}
                className='rounded-lg overflow-hidden'
                tabActiveClassName='bg-highlight text-color-white'
                arrowClassName='!hidden'
                tabsWrapperClassName='!mb-0'
                tabContentClassName='!p-0 !m-0'
            >
                <DataTab
                    tabKey='warrantyHistory'
                    title={translate('intl-msg:support.vehicleHistory.tabs.warrantyHistory')}
                >
                    <WarrantyHistory chassis={chassis} />
                </DataTab>
                <DataTab
                    tabKey='technicalSupportCalls'
                    title={translate('intl-msg:support.vehicleHistory.tabs.technicalSupportCalls')}
                >
                    <TechnicalSupportCalls chassis={chassis} customer={customer} />
                </DataTab>
                <DataTab tabKey='revisions' title={translate('intl-msg:support.vehicleHistory.tabs.revisions')}>
                    <Revisions chassis={chassis} />
                </DataTab>
                <DataTab tabKey='occurrences' title={translate('intl-msg:support.vehicleHistory.tabs.occurrences')}>
                    <Occurrences chassis={chassis} />
                </DataTab>
            </DataTabs>
        </div>
    );
}
